"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6673],{

/***/ 16673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BrandDescription": function() { return /* binding */ BrandDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _csc_dls_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45468);
/* harmony import */ var _csc_dls_Row__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69323);



var BrandDescription = function(param) {
    var brand_description_title = param.brand_description_title, brand_description = param.brand_description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls_Row__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        cols: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                size: "xl",
                bold: true,
                className: "mt-4 pt-2",
                children: brand_description_title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                size: "md",
                className: "text-primary",
                children: brand_description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BrandDescription);


/***/ }),

/***/ 45468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var ThemeContext = /*#__PURE__*/ React.createContext({
    themeId: "",
    typographyComponents: {},
    brandVariables: {}
});
var useTheme = function useTheme() {
    return React.useContext(ThemeContext);
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var LegacyText = function LegacyText(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.link, link = _e === void 0 ? false : _e;
    _a.id;
    var children = _a.children, _g = _a.textTag, textTag = _g === void 0 ? "p" : _g, rest = __rest(_a, [
        "className",
        "size",
        "bold",
        "link",
        "id",
        "children",
        "textTag"
    ]);
    var classes = "".concat(!!className ? className : "", " text-body-").concat(size, "-").concat(!!link ? "link" : !!bold ? "bold" : "normal");
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        className: classes,
        textTag: textTag
    }, rest), children);
};
var Text = function Text(_a) {
    var _b;
    var textId = _a.textId, className = _a.className, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "p" : _c, rest = __rest(_a, [
        "textId",
        "className",
        "children",
        "textTag"
    ]);
    var typographyComponents = useTheme().typographyComponents;
    if (!textId || !typographyComponents) {
        return /*#__PURE__*/ React__default["default"].createElement(LegacyText, _extends({
            className: className,
            textTag: textTag
        }, rest), children);
    }
    var props = __assign({
        className: "".concat(className || "", " ").concat(textId)
    }, rest);
    var inputTag = textTag || ((_b = typographyComponents === null || typographyComponents === void 0 ? void 0 : typographyComponents[textId]) === null || _b === void 0 ? void 0 : _b.htmlComponent);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: inputTag
    }, props), children);
};
__webpack_unused_export__ = LegacyText;
__webpack_unused_export__ = Text;
exports.ZP = Text; //# sourceMappingURL=Text.js.map


/***/ })

}]);